/*
  T0 Hex configurator — behaviour for blocks/t0-configurator.liquid.
  Port of the tierzerosports.com configurator logic: 5 target masses × 4 handle fits, config code
  T0H-{FIT}-{MASS} (default T0H-B-370). Selection resolves the product variant, keeps ?variant= in
  the URL (history.replaceState), writes the cfg: tag into any Series Zero form, and in the sale state
  keeps the buy form's variant, the shown price and Add to cart in step.
  Deep link: ?cfg=T0H-B-370 preselects. Also keeps the spec table's live rows ([data-t0-spec]) in step. No dependencies and no web storage (nothing is persisted in the browser).
*/
(() => {
  const CFG_RE = /^T0H-([A-D])-(\d{3})$/;
  // Same as snippets/t0-text.liquid: "T0" / "€0" get a true zero (DM Mono).
  const zeroText = (t) => String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;')
    .replace(/T0/g, 'T<span class="t0-zero">0</span>').replace(/€0/g, '€<span class="t0-zero">0</span>');

  function init(root) {
    if (root.dataset.t0Ready) return;
    root.dataset.t0Ready = 'true';

    let variants = [];
    try { variants = JSON.parse(root.querySelector('[data-t0-variants]').textContent); } catch (e) { variants = []; }

    const massInputs = [...root.querySelectorAll('[data-t0-mass]')];
    const fitInputs = [...root.querySelectorAll('[data-t0-fit]')];
    const massReadout = root.querySelector('[data-mass-readout]');
    const fitReadout = root.querySelector('[data-fit-readout]');
    const codeEl = root.querySelector('[data-cfg-code]');

    const check = (inputs, value) => {
      const hit = inputs.find((i) => i.value === value);
      if (hit) hit.checked = true;
      return Boolean(hit);
    };

    // ?cfg= deep link wins over the server-side default / ?variant= preselection.
    const params = new URLSearchParams(window.location.search);
    const cfgParam = (params.get('cfg') || '').toUpperCase();
    const m = CFG_RE.exec(cfgParam);
    if (m) { check(fitInputs, m[1]); check(massInputs, m[2]); }

    const current = () => ({
      mass: (massInputs.find((i) => i.checked) || {}).value || root.dataset.defaultMass,
      fit: (fitInputs.find((i) => i.checked) || {}).value || root.dataset.defaultFit,
    });

    function update(fromUser) {
      const { mass, fit } = current();
      const code = `T0H-${fit}-${mass}`;
      if (massReadout) massReadout.textContent = root.dataset.tolerances === 'false' ? `${mass} g` : `${mass} g · ± 1 g`;
      if (fitReadout) fitReadout.textContent = `Fit ${fit}`;
      if (codeEl) codeEl.textContent = code;

      // Form tags: base tags from the form block + this configuration.
      document.querySelectorAll('[data-t0-tags]').forEach((input) => {
        const base = input.dataset.baseTags || '';
        input.value = base ? `${base}, cfg:${code}` : `cfg:${code}`;
      });

      // Keep ?variant= in step with the selection (all 20 selectable; availability is ignored).
      const variant = variants.find((v) => v.mass === mass && v.fit === fit);
      // Spec table live rows (blocks/t0-spec-table.liquid): Article number, Mass, Handle fit.
      const live = { sku: variant && variant.sku, mass: `${mass} ± 1 g`, fit: variant && variant.fitLabel };
      document.querySelectorAll('[data-t0-spec]').forEach((el) => {
        const v = live[el.dataset.t0Spec];
        if (v) el.innerHTML = zeroText(v);
      });
      // Sale state (blocks/t0-sales-state.liquid): the buy form follows the selection — variant id,
      // shown price, and Add to cart only when this variant is available. The join state carries no
      // price in the variant map, so nothing here runs there.
      if (variant && 'price' in variant) {
        document.querySelectorAll('[data-t0-sales] form[data-type="add-to-cart-form"] input[name="id"]').forEach((input) => { input.value = variant.id; });
        document.querySelectorAll('[data-t0-sale-price]').forEach((el) => { el.textContent = variant.price; });
        document.querySelectorAll('[data-t0-sales] .add-to-cart-button').forEach((btn) => {
          btn.disabled = !variant.available;
          btn.toggleAttribute('data-t0-unavailable', !variant.available);
        });
      }
      if (variant) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        if (fromUser) url.searchParams.delete('cfg'); // a changed selection supersedes the deep link
        window.history.replaceState(window.history.state, '', url.toString());
      }
    }

    root.addEventListener('change', (e) => {
      if (e.target.matches('[data-t0-mass], [data-t0-fit]')) update(true);
    });
    update(false);
  }

  const run = () => document.querySelectorAll('[data-t0-configurator]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  // Theme editor: re-init when the block is re-rendered.
  document.addEventListener('shopify:section:load', run);
})();
